<!--首页两侧信息-->
<template>
  <div>
    <div class="hj-message-common-left hj-message animated fadeInLeft" v-show="box2show">
      <div class="hj-message-table-div">
        <table class="hj-message-table" v-loading="leftfiretopLoading">
          <thead class="hj-message-tabletitle">
            <tr>
              <th>单位名称</th>
              <th style="width: 20%">警报数量</th>
              <th style="width: 12%"></th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in unitbjList1.length ? unitbjList1 : unitbjList"
              :key="index"
              v-if="item"
              @click="getInfo(item.c_company_num, index, item.c_name, true)"
              :class="{ cursor: true, active: companyInfoIndex == index }"
            >
              <td style="text-align: left;padding-left:5px" :title="item.company || item.c_name">
                {{ item.company || item.c_name || item.cName }}
              </td>
              <td>{{ item.count || item.companycount }}</td>
              <td><i class="el-icon-view" @click="showMore(item)"></i></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <el-dialog :visible.sync="showMoreList" width="100%" :show-close="false" @close="close">
      <div slot="title" class="dialog-header">
        <div class="d-title flex1" style="position: relative">
          <i class="icon-tr-Real-time-alarm" style="padding-right: 5px"></i>
          <span style="color: white">历史报警信息</span>
        </div>

        <div class="d-right align-center">
          <span class="icon-tr-Close ml20" @click="showMoreList = false"></span>
        </div>
      </div>
      <div style="overflow: auto; height: 300px;" v-loading="moreLoad" class="form-item">
        <div class="ml20 flex searchform">
          <fm-generate-form :data="histsearch" ref="histsearch"></fm-generate-form>
          <div style="inline" class="ml10 el-form-last">
            <div v-if="histAll" style="width: 280px;margin-left:10px;">
              <span>单位名称:</span>
              <el-input class="ml10" style="width: 60%" size="small" v-model="listParams.company"> </el-input>
            </div>
            <span class="last-form" style="width:80px;">报警类型:</span>
            <el-select v-model="listParams.evenClass" size="small" class="ml10 last-form">
              <el-option v-for="item in Object.values(this.$map.bjStatus)" :key="item" :value="item">{{ item }}</el-option>
            </el-select>
          </div>
          <div class="last-btn" style="width: 240px;">
            <el-button type="primary ml20" @click="searchsub" size="small">查询</el-button>
            <el-button type=" ml20" @click="resetSearch" size="small">查看全部</el-button>
          </div>
        </div>
        <table class="hj-message-table" style="width: 100%">
          <thead>
            <tr>
              <th style="width: 15%">单位名称</th>
              <th style="width: 15%">报警时间</th>
              <th style="width: 15%">处理时间</th>
              <th style="width: 5%">报警类型</th>
              <th style="width: 14%">联系电话</th>
              <th style="width: 8%">设备类型</th>
              <th style="width: 15%">报警节点</th>
              <th style="width: 10%">报警地点</th>
              <th style="width: 10%">操作</th>
            </tr>
          </thead>
          <tbody class="tr_context_box">
            <tr
              v-for="(item, index) in companyInfo"
              :key="index"
              v-if="item.company"
              :class="(item.isLate > 20 || !item.dispose_time) && signaltype.indexOf(item.evenClass) > -1 ? 'mark' : ''"
            >
              <td>{{ item.company }}</td>
              <td>{{ item.nowtime }}</td>
              <td :title="item.dispose_time">{{ item.dispose_time }}</td>
              <td>{{ item.evenClass }}</td>
              <td>{{ item.phone }}</td>
              <td :title="item.deviceType">{{ item.deviceType }}</td>
              <td :title="item.context">{{ item.detailAddr }}</td>
              <td :title="item.msgDescribe">{{ item.msgDescribe }}</td>
              <td>
                <a title="查看点位" class="cursor" @click="openPoint(item)" style="color: #4a9dff">查看点位</a>
                <a v-if="item.dosomthing == 0" title="点击处理" class="cursor ml10" @click="CLdatail(index)" style="color: #4a9dff">处理</a>
                <span v-else @click="CLdatail(index)" class="ml10">已处理</span>
              </td>
            </tr>
          </tbody>
          <el-pagination
            background
            v-if="companyInfoCount > 10"
            layout="prev, pager, next"
            :page-size="listParams.limit || 10"
            @current-change="pageChange"
            :current-page.sync="listParams.page"
            :total="companyInfoCount"
          >
          </el-pagination>
        </table>

        <p class="mt20 tx-center" v-show="companyInfo.length == 0">没有更多</p>
      </div>
    </el-dialog>
    <el-dialog title="标定" :visible.sync="showBD" width="600PX">
      <div>
        <fm-generate-form :data="searchForm" :value="editData" ref="searchForm"></fm-generate-form>
      </div>
      <span slot="footer" class="dialog-footer center">
        <el-button @click="showBD = false">取 消</el-button>
        <el-button type="primary" @click="saveBD">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="处理任务" :visible.sync="showCL" :close-on-click-modal="false" v-if="showCL" width="50%">
      <div v-loading="leftfiretopLoading">
        <el-form ref="form" v-model="clForm" label-width="110px">
          <el-form-item prop="tr_name" label="单位名称:">
            {{ clForm.company }}
          </el-form-item>
          <el-form-item prop="tr_name" label="设备名称:"> </el-form-item>
          <el-form-item prop="tr_name" label="设备型号:">
            {{ clForm.address }}
          </el-form-item>
          <el-form-item prop="tr_sign_time" label="报警时间:">
            {{ clForm.nowtime }}
          </el-form-item>
          <el-form-item prop="tr_name" label="报警类型:">
            {{ clForm.evenClass }}
          </el-form-item>

          <el-form-item label="报警地点:">
            {{ clForm.msgDescribe }}
          </el-form-item>
          <el-form-item label="报警设备:">
            {{ clForm.deviceType }}
          </el-form-item>

          <el-form-item label="报警点位:">
            {{ clForm.detailAddr }}
          </el-form-item>
          <el-form-item label="处理单号:">
            {{ clForm.id }}
          </el-form-item>

          <el-form-item label="处理人员:">
            {{ $local.get('userInfo').username }}
          </el-form-item>
          <el-form-item label="处理内容:">
            <el-input type="textarea" v-model="clForm.context"></el-input>
          </el-form-item>
          <el-form-item label="是否误报:">
            <el-checkbox v-model="clForm.wubao">误报</el-checkbox>
          </el-form-item>
        </el-form>
        <div class="center" v-if="clForm.dosomthing == 0">
          <el-button type="primary" @click="handleById()" size="small">确定</el-button>
          <el-button @click="showCL = false" size="small">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showstatic" width="90%" title="设备实时状态" :show-close="true">
      <device :c_number="unitInfo.c_company_num || ''"></device>
    </el-dialog>
    <el-dialog title="单位详情" style="min-height: 500px" :visible.sync="showmod" width="100%" :close-on-click-modal="false">
      <company :c_num="unitInfo.c_company_num" />
    </el-dialog>
    <!-- 上传火警 -->
    <el-dialog :title="`上传${upform.c_name}火警信息`" style="min-height: 500px" :visible.sync="uploadmod" width="25%" :close-on-click-modal="false">
      <el-form ref="form" v-model="upform" label-width="110px">
        <el-form-item prop="tr_name" label="单位名称:">
          {{ upform.c_name }}
        </el-form-item>
        <el-form-item prop="tr_name" label="上传时间:">
          {{ upform.nowtime }}
        </el-form-item>
        <el-form-item prop="tr_name" label="情况描述:">
          <el-input type="textarea" v-model="upform.remark"></el-input>
        </el-form-item>
      </el-form>
      <div class="center">
        <el-button type="primary" @click="uploadWT">确认并上传</el-button>
        <el-button @click="uploadmod = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看点位信息" width="80%" style="height:95%" :visible.sync="crtpoint" custom-class="crtVideoDia">
      <crtmark :compnum="crtcompany" ref="crtmark" :nowtime="companyInfoCount.nowtime"></crtmark>
    </el-dialog>
  </div>
</template>
<script>
import echarts from 'echarts';
import device from '@/components/online-static';
import company from '@/components/company.vue';
import { getTime } from '@/api/common';
import crtmark from '@/components/crtpoints.vue';
import { getHjMsg, handleById } from '@/api/home';
import { mapState } from 'vuex';

export default {
  components: { device, company, crtmark },
  computed: {
    ...mapState(['isMute', 'isWaring', 'bjList', 'isLoop', 'showFire', 'alarmDtItem']),
  },
  data() {
    return {
      showMoreCount: false,
      topCompany: [
        { key: 'allCompanyNum', label: '所有单位', value: '' },
        { key: 'focusCompanyNum', label: '重点单位', value: 41 },
        { key: 'highFireRiskNum', label: '高危单位', value: 40 },
        { key: 'nineSmallCompanyNum', label: '九小场所', value: 42 },
        { key: 'generallyCompanyNum', label: '一般单位', value: 39 },
      ],
      todayFireTotal: 0, // 今日火警总数
      checkAll: false,
      todayFirePercent: '',
      searchForm: this.$getForm('bdform'),
      c_portList: [], // 上方服务类型
      options: [], // 省市区
      selectedArea: '',
      selectServiceType: [],
      companyInfomation: {},
      histsearch: this.$getForm('historysearch'),
      noPolice: this.$store.state.noPolice || [],
      editData: {},
      signaltype: ['火警', '手动报警', '超限', '漏电'],
      showstatic: false,
      leftfiretopLoading: false,
      pointRank: this.$store.state.compList || [], // p
      moreLoad: false,
      leftfiredownLoading: false,
      rightLoading: false, // 右侧单位信息
      showBD: false,
      box1show: true,
      showmod: false, //单位信息
      uploadmod: false, // 上传信息
      deviceload: false,
      crtpoint: false, // crt点位信息
      company: '',
      crtcompany: {},
      companyInfoCount: 0,
      box2show: true,
      box3show: true,
      box4show: true,
      box5show: true,
      box6show: true,
      box7show: true,
      rightPointLoading: false,
      hasPoint: true,
      showCL: false,
      histAll: false, // 是否查询全部历史
      companyInfoIndex: 0,
      showMoreMsg: false,
      showMoreList: false,
      MsgList: [],
      unitrole: {},
      CLIndex: 0,
      moreList: [],
      companyInfo: [],
      // 上传火警表单
      upform: {
        remark: '',
        nowtime: '',
        sc_user: this.$store.state.userInfo.username,
        DType: 199,
      },
      // 所有单位筛选查询

      leftFindParams: {
        areaList: [],
        cportList: [],
        supervisionLevel: '',
      },
      // 首页上方单位数量筛选
      topCompanyCount: {},
      clForm: {
        context: '',
        wubao: false,
      },
      msgLoading: false,
      bjType: 'firecompany',
      numInfo: {},
      selectStyle: 1, //
      unit: 'network',
      comnyInfo: '',
      msgParams: {
        page: 1,
        limit: 10,
        dosomthing: '',
        maxPage: 2,
        evenClass: '火警',
      },
      listParams: {
        page: 1,
        limit: 10,
        evenClass: '火警',
        company: '',
        c_company_num: '',
        maxPage: 2,
        type: '火警',
        starttime: '',
        endtime: '',
      },
      evenClass: 'fire',
      unitData: {},
      unitInfo: {},
      unitList: [],
      unitbjList: [],
      unitbjList1: [],
      todayBj: [],
      dateArray: [],
      BDform: {},
      onlineList: [],
      leaveList: [],
      dwpage: 1,
      destoryList: false,
    };
  },
  created() {
    // this.gettime(this.listParams);
  },
  mounted() {
    this.getLwList(true);
  },
  methods: {
    close() {
      log('关闭Dialog');
      this.listParams.page = 1;
    },
    // 顶部服务类型
    // changeUnitTop() {},
    clearGetList() {
      this.leftFindParams = {
        areaList: [],
        cportList: [],
        supervisionLevel: '',
      };
      this.getLwList(true);
    },
    linkSearch(e) {
      if (this.topCompanyCount[e.key] == 0) {
        return;
      }
      console.log(e.value);
      this.leftFindParams.supervisionLevel = e.value;
      this.getLwList(true);
    },
    areaChange() {
      console.log(this.selectedArea);
      var arr = [];
      this.selectedArea.find((item) => {
        arr.push(item[0]);
      });
      this.leftFindParams.areaList = arr;
      this.getLwList(true);
    },
    changeTopService(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === Object.keys(this.$map.bjStatus).length;
      this.leftFindParams.cportList = this.selectServiceType;
      this.getLwList(true);
    },

    // 选择地区
    showPoint() {
      this.$router.push({
        path: '/report/report-list',
      });
    },
    stat() {
      // 更多设备
      this.showstatic = true;
    },
    gotoBD(it) {
      this.BDform = it;
      this.showBD = true;
    },
    uploadWT() {
      this.$post('jiejing/jjstart', this.upform).then((res) => {
        // this.$message.success('火警上报成功');
        this.$message({
									message: "火警上报成功",
									type: 'success',
									duration: 700,
								});
        this.uploadmod = false;
      });
    },
    // crt点位
    openPoint(it) {
      var obj = { c_number: it.c_company_num, number: it.detailAddr || '' };
      this.$post('crt/crtselect', obj).then((res) => {
        if (!(res.data.length && res.data[0].area_uuid)) {
          // alert('无')
          this.$message.warning('该区域无点位标注，请联系管理员');
          return;
        }
        this.crtcompany = obj;
        this.crtpoint = true;
        // data[0]:报警的点位图及点位，闪动的点位
        //  data[1]:闪动的摄像头信息
        // data[2]:该点位图下绑定的其他点位位置
      });
    },

    // 服务类型全选

    handleCheckAllChange(val) {
      var arr = [];

      this.c_portList.map((it) => {
        arr.push(it.code);
      });

      this.selectServiceType = val ? arr : [];
      setTimeout(() => {
        this.getLwList(true);
      }, 100);
    },
    sear() {
      this.unitbjList1 = [];
      if (!this.company) {
        return;
      }
      if (this.unitbjList.length) {
        this.unitbjList.map((item) => {
          if (item) {
            var searchStr = item.company || item.c_name;
            if (searchStr.indexOf(this.company) > -1) {
              this.unitbjList1.push(item);
            }
          }
        });
      }
    },

    getNowTime(type) {
      let time = new Date(+new Date() + 8 * 3600 * 1000)
        .toJSON()
        .substr(0, 19)
        .replace('T', ' ')
        .replace(/-/g, '/');
      let timeLine = new Date(time).getTime();
      return new Date(timeLine).Format(type || 'yyyy年MM月dd日 hh:mm:ss');
    },

    gettime(PAR) {
      let time = new Date(+new Date() + 8 * 3600 * 1000)
        .toJSON()
        .substr(0, 19)
        .replace('T', ' ')
        .replace(/-/g, '/');
      let timeLine = new Date(time).getTime();
      PAR.starttime = new Date(timeLine).Format('yy年MM月dd日 00:00:00');
      PAR.endtime = new Date(timeLine).Format('yy年MM月dd日 23:59:59');
      this.getInfoList(PAR);
    },
    searchsub() {
      this.$refs.histsearch
        .getData()
        .then((data) => {
          this.listParams = { ...this.listParams, ...data };
          this.listParams.page = 1;
          // console.log(this.listParams);
          this.getHistAll(this.listParams);

          return;
        })
        .catch((e) => {});
    },
    resetSearch() {
      this.$refs.histsearch.reset();
      var params = { ...this.listParams, ...this.$refs.histsearch.models };
      params.page = 1;
      params.company = '';
      params.evenClass = '火警';

      this.getHistAll(params, true);

      this.histAll = true;
      this.listParams = params;

      this.listParams.c_company_num = '';
    },
    getMore(val) {
      if (val == true) {
        this.histAll = val;
      } else {
        this.histAll = false;
      }
      this.showMoreList = true;
    },

    // 收到报警该单位置顶
    changPosition() {
      if (this.bjList.length) {
        var c_numb = this.bjList[0].c_company_num;

        var eClass = this.bjList[0].evenClass;
        if (eClass === '火警' || eClass === '高温') {
          var change = false;
          for (var i = 0; i < this.unitbjList.length; i++) {
            if (this.unitbjList[i].c_company_num === c_numb) {
              console.log(this.unitbjList);
              change = true;
              var item = this.unitbjList[i];
              item.companycount ? item.companycount++ : item.count++;
              this.unitbjList.splice(i, 1);
              this.unitbjList.unshift(item);
              this.todayFireTotal++;
            }
          }
          if (!change) {
            this.getLwList(true);
          }
        }
      }
    },
    getDate() {
      var myDate = new Date(); //获取今天日期
      myDate.setDate(myDate.getDate() - 6);
      var dateArray = [];
      var dateTemp;
      var flag = 1;
      for (var i = 0; i < 7; i++) {
        dateTemp = myDate.getMonth() + 1 + '-' + myDate.getDate();
        dateArray.push(dateTemp);
        myDate.setDate(myDate.getDate() + flag);
      }
      this.dateArray = dateArray.reverse();
    },

    pageChange(val) {
      // console.log(val)
      this.listParams.page = val;
      if (this.histAll) {
        this.getHistAll(this.listParams, true);
      } else {
        this.getHistAll(this.listParams);
      }
    },
    //处理详情
    CLdatail(index, object) {
      this.CLIndex = index;
      var obj = object || this.companyInfo[index];
      for (var i in obj) {
        this.clForm[i] = obj[i];
      }
      this.clForm.type = obj.evenClass;
      this.clForm.context = this.clForm.context ? this.clForm.context : '';
      this.showCL = true;
    },

    //报警信息类
    getInfoma() {
      if (this.bjList.length) {
        var c_num = this.bjList[0].c_company_num;
        this.getUnit(c_num);
        this.getPointChart(c_num);
        if (!this.showMoreList) {
          this.listParams.c_company_num = c_num;

          this.getInfoList(this.listParams);
        }
      }
    },
    saveBD() {
      this.$refs.searchForm.getData().then((data) => {
        // log( this.unitbjList[this.companyInfoIndex].c_company_num)
        // log(data)
        var params = {
          ...data,
          c_number: this.BDform.c_company_num,
        };
        if (!params.starttime || !params.endtime || !params.type) {
          this.$message.warning('请填写正确时间信息');
          return;
        }
        this.showBD = false;

        if (params.type === '无') {
          this.$post('/demarcate/delebyc_number/' + params.c_number).then((res) => {
            // this.$message.success('标定成功');
            this.$message({
									message: "标定成功",
									type: 'success',
									duration: 700,
								});
            this.editData = {};
            this.BDform = {};
            this.getLwList();
            // this.getUnitNum();
            this.$refs.searchForm.reset();
          });
        } else {
          // log(params)
          this.$post('/demarcate/savedemarcate', params).then((res) => {
            // this.$message.success('标定成功');
            this.$message({
									message: "标定成功",
									type: 'success',
									duration: 700,
								});
            this.editData = {};
            this.$refs.searchForm.reset();
            this.getLwList();
            // this.getUnitNum();
          });
        }
      });
    },
    // 查看更多
    showMore(it) {
      this.listParams.c_company_num = it.c_company_num;
      this.listParams.company = '';
      this.getHistAll(this.listParams);
      this.showMoreList = true;
    },
    //一键处理
    handleByCom(id, it) {
      this.$confirm('确定一键处理该单位报警信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$post('/monitor/dealday', {
          c_number: id,
          dispose_time: this.getNowTime(null),
          dealName: this.$local.get('userInfo').nickName,
        }).then((res) => {
          console.log(res.date[0].countnotlist);
          // this.$message('处理成功');
          this.$message({
									message: "处理成功",
									type: 'success',
									duration: 700,
								});

          this.getLwList(true);

          this.$store.commit('detailAll', res.date[0].countnotlist);
        });
      });
    },
    getHistory() {
      this.$post('/monitor/findonlytwentycount').then((res) => {
        this.todayBj = res;
      });
    },

    // 获取左上角 联网单位 报备单位分类即数量

    getLwList(isfirst) {
      this.leftfiretopLoading = true;
      this.rightLoading = true;
      this.$post('/things/frontPage/leftFind', this.leftFindParams).then((res) => {
        this.topCompanyCount = res.data.supervisionLevel;

        this.options = res.data.areaList;
        this.c_portList = res.data.cportList;
        this.unitData = res.data.leftFindFrontPage;
        for (var i in this.unitData) {
          if (!this.unitData[i]) this.unitData[i] = [];
        }
        this.getUnitNum(isfirst);

        this.getMessageNum();
        this.getFireCountAll();
        // alert(3)
        setTimeout(() => {
          this.$parent.getList({ data: res.data.leftFindCompanyInfo });
        }, 100);
      });
    },
    // 左上角 联网单位
    getUnitNum(isfirst) {
      this.leftfiretopLoading = true;
      this.$post('/things/frontPage/fireAlarm', this.leftFindParams).then((res) => {
        var obj = {};
        // 火警
        obj.firecompany = res.data.fireCompany || [];
        obj.errcompany = res.data.faultCompany || [];
        obj.defindcompany = res.data.shieldCompany || [];
        obj.watercompany = res.data.waterCompany || [];
        obj.electcompany = res.data.electricalMonitorCompany || [];
        obj.wififirecompany = res.data.wirelessGasCompany || [];
        obj.wifismokecompany = res.data.smokeCompany || [];
        obj.wirelessGasCompany = res.data.wirelessGasCompany || [];
        obj.highGasCompany = res.data.highGasCompany || [];
        this.unitrole = obj;
        if (isfirst) {
          this.changeType('firecompany');
          if (!this.unitbjList.length) {
            this.changeUnit('network');
          }
          // this.getInfo(this.unitbjList[0].c_number, 0);
        }
        this.leftfiretopLoading = false;
      });
    },
    // 左上角火警总数echart图以及数量
    getFireCountAll() {
      this.$post('/things/frontPage/fireAlarmsNumToday', this.leftFindParams).then((res) => {
        console.log(res);
        this.todayFireTotal = res.data.allAlarmCount;
        this.todayFirePercent = res.data.percentStr;
        var todayValue = [];
        var yesTerday = [];
        var timeLine = [];
        res.data.fireAlarmsNumToday.map((item) => {
          todayValue.push(item.num);
          timeLine.push(item.time);
        });
        res.data.fireAlarmsNumYesterday.map((item) => {
          yesTerday.push(item.num);
        });
        // 处理
        this.makeline({
          content: 'device-count',
          config: {
            title: {
              show: false,
            },

            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                label: {
                  backgroundColor: '#6a7985',
                },
              },
            },
            xAxis: [
              {
                axisTick: {
                  show: false,
                },
                axisLine: {
                  show: false,
                },
                type: 'category',

                boundaryGap: false,
                data: timeLine,
                axisLabel: {
                  show: true,
                  textStyle: {
                    color: 'rgba(146, 146, 193, 1)',
                    fontSize: '7px',
                  },
                },
              },
            ],
            grid: {
              left: 20,
              right: 20,
              bottom: '30%',
              top: '40%',
            },
            legend: [
              {
                itemWidth: 30,
                itemHeight: 10,
                orient: 'vertical',
                data: ['昨天', '今天'],
                left: 'center',
                orient: 'horizontal',
                bottom: '0',
                align: 'center',
                padding: [0, 10],
                textStyle: {
                  color: '#000',
                },
              },
            ],
            yAxis: [
              {
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
                name: '',
                type: 'value',
                splitLine: {
                  show: false,
                },
                minInterval: 1,
                axisLabel: {
                  show: false,
                  textStyle: {
                    color: '#000',
                  },
                },
              },
            ],
            series: [
              {
                name: '昨天',
                type: 'line',
                stack: '昨天',
                itemStyle: {
                  color: 'rgba(146, 146, 193, 1)',
                },
                data: yesTerday,
              },
              {
                name: '今天',
                type: 'line',
                stack: '今天',
                itemStyle: {
                  color: new echarts.graphic.LinearGradient(
                    0,
                    0,
                    1,
                    1,
                    [
                      { offset: 0, color: ' rgba(77, 161, 255, 1)' },
                      { offset: 1, color: 'rgba(77, 255, 223, 1)' },
                    ],
                    false,
                  ),
                },
                data: todayValue,
                // data:[0,1,1,1,0,1,1]
              },
            ],
          },
        });
      });
    },

    //切换右侧
    async changeType(val) {
      this.bjType = val;

      console.log(val);
      // var data = this.$map.bjType[val];
      // var reg = new RegExp("单位");
      // data = data.replace(reg, "");
      this.unitbjList = this.unitrole[val] ? this.unitrole[val] : [];
      this.unitbjList.map((item) => {
        item.c_company_num = item.companyNum;
        item.c_name = item.company;
      });
      if (this.unitbjList.length) {
        this.getInfo(this.unitbjList[0] ? this.unitbjList[0].c_company_num : this.unitbjList[0].c_number, 0, false);
      }

      this.leftfiretopLoading = false;
      this.selectStyle = 1;
      // await this.$post("demarcate/allcompanyshowslefttopnew", {
      //   evenClass: data,
      // }).then((res) => {
      //   var arr = [];
      //   res.data.map((item, index) => {
      //     var obj = {
      //       c_name: item.company,
      //       count: item.value,
      //       c_company_num: item.c_company_num,
      //     };
      //     arr.push(obj);
      //   });
      //   this.unitbjList = arr;
      //   this.leftfiretopLoading = false;
      // });
    },
    changeUnit(val, isfirst) {
      this.unit = val;
      this.unitbjList = this.unitData[val] ? this.unitData[val] : [];
      console.log(this.unitbjList);
      this.unitbjList.map((item) => {
        item.c_name = item.cName;
        item.c_company_num = item.cCompanyNum;
      });
      if (this.unitbjList.length) {
        this.getInfo(this.unitbjList[0] ? this.unitbjList[0].c_company_num : this.unitbjList[0].c_number, 0, false);
      }

      this.leftfiretopLoading = false;
      this.selectStyle = 2;
    },
    changeStatus(val) {
      this.evenClass = val;
      this.msgParams.evenClass = this.$map.leftStatus[val];
      this.listParams.type = this.$map.leftStatus[val];

      // this.gettime(params)
      // this.getInfoList({
      //     c_company_num: this.listParams.c_company_num,
      //     page: 1,
      //     limit: 10,
      //     type: this.$map.leftStatus[val]
      // })
      this.gettime({
        c_company_num: this.listParams.c_company_num,
        page: 1,
        limit: 10,
        type: this.$map.leftStatus[val],
      });
    },
    getHjMsg() {
      if (this.msgParams.page > this.msgParams.maxPage) {
        return;
      }
      this.msgLoading = true;
      getHjMsg(this.msgParams).then((res) => {
        this.MsgList.push(...res.countnotlist);
        this.msgParams.page += 1;
        this.msgParams.maxPage = Math.ceil(res.count / this.msgParams.limit);
        this.msgLoading = false;
      });
    },
    // checkS(type){
    //     this.msgParams.dosomthing = type;
    //     this.msgParams.page = 1;
    //     this.MsgList = []
    //     this.getHjMsg()
    // },
    // 获取单位信息
    getInfo(c_number, index, name, a) {
      if (a) {
        // this.getInfoList(this.listParams);

        this.$emit('local', c_number);
        this.listParams.page = 1;
      }
      this.rightLoading = true;
      // this.rightPointLoading = true
      this.companyInfoIndex = index;
      // this.listParams.c_company_num = c_number;
      this.listParams.company = '';
      this.comnyInfo = name;
      this.getUnit(c_number);
      // this.getHistAll(this.listParams);
      // this.getDeviceState(c_number);
      this.getPointChart(c_number);
    },

    //发起请求当前公司设备

    getDeviceState(c_number) {
      this.deviceload = true;

      this.$post('/demarcate/devicesshebei', { company_id: c_number }).then((res) => {
        // return
        var {
          device,
          device_size,
          device_oldfive,
          device_oldfive_size,
          device_oldfour,
          device_oldfour_size,
          device_oldsix,
          device_oldsix_size,
          device_oldthree,
          device_oldthree_size,
          device_oldtwo,
          device_oldtwo_size,
          device_one,
          device_one_size,
        } = res.data;
        this.onlineList = [device_size, device_one_size, device_oldtwo_size, device_oldthree_size, device_oldfour_size, device_oldfive_size, device_oldsix_size];
        this.leaveList = [
          device ? device.length - device_size : 0,
          device_one ? device_one.length - device_one_size : 0,
          device_oldtwo ? device_oldtwo.length - device_oldtwo_size : 0,
          device_oldthree ? device_oldthree.length - device_oldthree_size : 0,
          device_oldfour ? device_oldfour.length - device_oldfour_size : 0,
          device_oldfive ? device_oldfive.length - device_oldfive_size : 0,
          device_oldsix ? device_oldsix.length - device_oldsix_size : 0,
        ];
        // this.makeline({ content: "device-count" });
      });
    },
    getPointChart(company_num) {
      // this.rightPointLoading = true
      this.$post('/phpcontro/scorepicture', { company_id: company_num }).then((res) => {
        if (res.data && res.data.length) {
          this.hasPoint = true;
          var arr = [];
          res.data.map((item) => {
            var obj = { name: item.label, value: Number(item.value) };
            arr.push(obj);
          });

          setTimeout(() => {
            this.makecir(arr);
          }, 20);
        } else {
          this.hasPoint = false;
        }
        // this.rightPointLoading = false
      });
    },
    getUnit(c_number) {
      var firstLoading = false;
      var secondLoading = false;
      var thirdloading = false;
      // getUnit(c_number).then(res => {
      //     this.unitInfo = res.list.detail[0] || {}
      // })
      this.$post('devicemanage/basesdetail', { c_company_num: c_number }).then((res) => {
        this.unitInfo = res.data || {};
        firstLoading = true;
      });
      this.$get('things/frontPage/companyInfo', { companyNum: c_number }).then((res) => {
        console.log(res);
        this.companyInfomation = res.data;
        this.getSheshi();
        this.getDeviceOnline();
        secondLoading = true;
      });

      this.$get('/things/frontPage/moonCompanyAlarm', {
        companyNum: c_number,
      }).then((res) => {
        setTimeout(() => {
          this.getAlarmCount(res.data);
          this.thirdloading = true;
          if (firstLoading && secondLoading && thirdloading);
          this.rightLoading = false;
        }, 1000);
      });
    },
    // 获取 报警统计chart
    getAlarmCount(data) {
      // console.log(data);
      var trafficWay = [
        {
          name: '火警',
          value: (data.fireAlarm / data.allInfo) * 100,
        },
        {
          name: '故障',
          value: (data.fault / data.allInfo) * 100,
        },
        {
          name: '屏蔽',
          value: (data.shield / data.allInfo) * 100,
        },
        {
          name: '复位',
          value: (data.reset / data.allInfo) * 100,
        },
        {
          name: '监管',
          value: (data.supervision / data.allInfo) * 100,
        },
        {
          name: '启动',
          value: (data.startUp / data.allInfo) * 100,
        },
      ];
      var all = data.allInfo;
      var data = [];
      var color = [
        new echarts.graphic.LinearGradient(
          0,
          0,
          1,
          1,
          [
            { offset: 0, color: '  rgba(255, 122, 0, 1)' },
            { offset: 1, color: 'rgba(255, 230, 101, 1)' },
          ],
          false,
        ),
        new echarts.graphic.LinearGradient(
          0,
          0,
          1,
          1,
          [
            { offset: 0, color: '  rgba(77, 255, 223, 1)' },
            { offset: 1, color: 'rgba(77, 161, 255, 1)' },
          ],
          false,
        ),

        '#fd5151',
        '#65e5dd',
        '#7b2cff',
        new echarts.graphic.LinearGradient(
          0,
          0,
          1,
          1,
          [
            { offset: 0, color: ' rgba(94, 255, 101, 1)' },
            { offset: 1, color: 'rgba(90, 255, 213, 1)' },
          ],
          false,
        ),
      ];
      for (var i = 0; i < trafficWay.length; i++) {
        data.push(
          {
            value: trafficWay[i].value,
            name: trafficWay[i].name,
            itemStyle: {
              normal: {
                borderWidth: 10,
                shadowBlur: 0,
                borderRadius: 20, // 圆角
                borderColor: color[i],
                shadowColor: color[i],
              },
            },
          },
          {
            value: 8,
            name: '',
            itemStyle: {
              normal: {
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
                color: 'rgba(0, 0, 0, 0)',
                borderColor: 'rgba(0, 0, 0, 0)',
                borderWidth: 0,
              },
            },
          },
        );
      }
      // console.log(data);
      this.makeline({
        content: 'alarm-count-chart',
        config: {
          backgroundColor: '#fff',
          color: color,
          tooltip: {
            show: false,
          },
          toolbox: {
            show: false,
          },
          title: [
            {
              // 第一个圆环标题
              text: all, // 主标题
              textStyle: {
                // 主标题样式
                color: '#fff',
                lineHeight: 10,
                fontSize: '38rem',
                fontWeight: '400',
              },

              left: '68%', // 定位到适合的位置
              top: '40%', // 定位到适合的位置
              subtext: '月报警总数', // 副标题
              subtextStyle: {
                // 副标题样式
                color: '#fff',
                top: '0%',
                fontSize: '34rem',
              },
              textAlign: 'center', // 主、副标题水平居中显示
            },
          ],
          legend: [
            {
              itemWidth: 10,
              itemHeight: 10,
              orient: 'vertical',
              data: ['火警', '故障', '屏蔽', '复位', '监管', '启动'],
              left: '3%',
              top: 'center',
              align: '',
              padding: [0, 0],
              textStyle: {
                color: '#000',
              },
              itemGap: 15,
            },
          ],
          series: [
            {
              name: '1',
              type: 'pie',
              clockWise: false,
              radius: ['83%', '85%'],
              hoverAnimation: false,
              center: ['70%', '50%'],
              itemStyle: {
                normal: {
                  label: {
                    show: false,
                  },
                },
              },
              data: data,
            },
            {
              type: 'pie',
              radius: ['0%', '45%'], //第一项是内半径，第二项是外半径。
              center: ['70%', '50%'],
              hoverAnimation: false,
              color: 'rgba(62, 182, 238, 1)',
              data: [
                {
                  value: 6754,
                  itemStyle: {
                    normal: {
                      shadowColor: '#e3e3e3',
                      shadowBlur: 20,
                    },
                  },
                },
              ],
            },
          ],
        },
      });
    },
    // 设备在线方法
    getDeviceOnline() {
      // var arr= []
      var numBer = (this.companyInfomation.onlineTransmission / this.companyInfomation.allTransmission) * 100;
      setTimeout(() => {
        this.makeline({
          content: 'device-count-chart',
          config: {
            series: [
              {
                type: 'gauge',
                detail: {
                  formatter: '{value}%',
                  show: false,
                },

                data: [
                  {
                    value: numBer,
                    name: 'Percent',
                  },
                ],
                clockwise: true,
                axisLine: {
                  show: true,
                  lineStyle: {
                    // 属性lineStyle控制线条样式
                    color: [
                      [0, 'rgba(94, 255, 90, 1)'],
                      [1, 'rgba(90, 255, 225, 1)'],
                    ],
                    width: 10,
                  },
                },
                splitLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                  splitNumber: 5,
                },
                axisLabel: {
                  show: false,
                },
                pointer: {
                  length: '57%',
                },
                itemStyle: {
                  borderColor: null,
                },
                title: {
                  show: false,
                },
                radius: '100%',
              },
            ],
          },
        });
      }, 1000);
    },

    // 右侧消防设施echart

    getSheshi() {
      var arr = [
        {
          content: 'sheshi',
          value: this.companyInfomation.fireFacilitiesFlag,
          name: this.companyInfomation.fireFacilitiesFlag,
        },
        {
          content: 'drill',
          value: this.companyInfomation.planFlag,
          name: this.companyInfomation.planFlag,
        },
        {
          content: 'chagang',
          value: this.companyInfomation.queryJobScaleFlag,
          name: this.companyInfomation.queryJobScaleFlag,
        },
      ];
      setTimeout(() => {
        arr.map((item) => {
          this.makeline({
            content: item.content,
            config: {
              title: [
                {
                  text: (item.value == 100 && item.content !== 'chagang' ? '已建成' : '未建成') || item.content == 'chagang' ? item.value + '%' : '未完成',
                  x: 'center',
                  y: 'center',
                  textStyle: {
                    fontSize: '9',
                    color: '#000',
                    fontFamily: 'DINAlternate-Bold, DINAlternate',
                    fontWeight: 'normal',
                  },
                },
              ],
              tooltip: {
                show: false,
              },
              backgroundColor: '#fff',
              polar: {
                radius: ['42%', '52%'],
                center: ['50%', '50%'],
              },
              angleAxis: {
                max: 100,
                show: false,
              },
              radiusAxis: {
                type: 'category',
                show: true,
                axisLabel: {
                  show: false,
                },
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
              },
              series: [
                {
                  name: '',
                  type: 'bar',
                  roundCap: true,
                  barWidth: 30,
                  showBackground: true,
                  backgroundStyle: {
                    color: item.value == 0 ? 'rgba(112, 112, 112, 1)' : '#fff',
                  },
                  data: [Number(item.value)],
                  coordinateSystem: 'polar',
                  itemStyle: {
                    normal: {
                      color: new echarts.graphic.LinearGradient(
                        0,
                        1,
                        0,
                        0,
                        item.value == 100
                          ? [
                              { offset: 0, color: '#16CEB9' },
                              { offset: 1, color: '#6648FF' },
                            ]
                          : [
                              { offset: 0, color: ' rgba(255, 146, 45, 1)' },
                              { offset: 1, color: 'rgba(255, 45, 46, 1)' },
                            ],
                      ),
                    },
                  },
                },
              ],
            },
          });
        });
      }, 1000);
    },

    load() {
      if (this.msgParams.page <= this.msgParams.maxPage && !this.msgLoading) {
        this.getHjMsg();
      }
    },
    loadList() {
      if (this.listParams.page <= this.listParams.maxPage && !this.msgLoading) {
        this.getHjList();
      }
    },
    getHjList() {
      // this.moreList = []
      // this.msgLoading = true
      // getMoreHjList(this.listParams).then(res => {
      //     //this.moreList.push(...res.countnotlist)
      //     this.moreList.push(...res.allcountlist)
      //     //this.listParams.page += 1
      //     //this.listParams.maxPage = Math.ceil(res.allcount / this.listParams.limit)
      //     this.msgLoading = false
      // })
    },
    getHistAll(obj) {
      // console.log(this.histAll);
      this.moreLoad = true;
      // obj= obj || {}
      // for (var i in this.listParams) {
      //   obj[i] = this.listParams[i];
      // }
      this.$post('/monitor/selectalljilu', obj).then((res) => {
        // console.log(res);
        res.data?.map((item) => {
          // console.log(item, 'set item');
          if (item.nowtime && item.dispose_time) {
            item.isLate = this.changeTime(item.dispose_time, item.nowtime);
          } else {
            item.isLate = false;
          }
        });
        this.companyInfoCount = res.count;
        this.$set(this, 'companyInfo', res.data);
        this.moreLoad = false;
      });
    },
    getInfoList(params, first, hist) {
      // this.leftfiredownLoading = true
      // getHjNum(params).then(res => {
      //     this.numInfo = res
      // getMoreHjList(params).then(res => {
      //     log(res)
      //     //this.companyInfo = res.countnotlist
      //     this.$set(this, 'companyInfo', res.countnotlist)
      // })
      // var  sumUrl = hist ? 'demarcate/donotdo' : 'leftview/viewInfoBottomevery'
      var today = false;
      var starttime = params.starttime.substring(0, params.starttime.indexOf(' '));
      var nowtime = this.$local.get('nowtime').substring(0, this.$local.get('nowtime').indexOf(' '));

      var endtime = params.endtime.substring(0, params.starttime.indexOf(' '));

      if (nowtime === starttime && nowtime === endtime) {
        today = true;
      }
      // this.listParams = params;
      this.getHistAll(params);

      return;
      this.getHistAll();
      var numUrl = today ? 'leftview/viewInfoBottom' : 'demarcate/donotdodata';

      alert(JSON.stringify(params));

      if (params.c_company_num && !first) {
        this.$post('leftview/viewInfoBottomevery', params).then((res) => {
          var { list0, list1, list2, list3, list4, list5, list6, list7, list8, list9, list10, list11, list12 } = res.data;
          var obj = {
            屏蔽: list2,
            火警: list0,
            故障: list1,
            复位: list3,
            监管: list4,
            启动: list5,
            反馈: list6,
            恢复: list7,
            手动火警: list8,
            通用: list9,
            水系统: list10,
            漏电: list11,
            高温: list12,
          };

          this.numInfo = obj;
        });
        params.evenClass = params.type;
        this.$post(numUrl, params).then((res) => {
          //this.companyInfo = res.data.list

          res.data.list.map((item) => {
            if (item.nowtime && item.dispose_time) {
              item.isLate = this.changeTime(item.dispose_time, item.nowtime);
            } else {
              item.isLate = false;
            }
          });

          this.$set(this, 'companyInfo', res.data.list);
          this.companyInfoCount = res.data.count;
          this.leftfiretopLoading = false;
          this.moreLoad = false;
        });
        this.listParams = params;

        // this.leftfiredownLoading=false
      }
    },

    changeTime(timeNow, timeBefore) {
      var _this = this;

      function changeStr(str) {
        // var str = _this.$local.get('nowtime')
        str = str.replace(/年/g, '/');
        str = str.replace(/月/g, '/');
        str = str.replace(/日/g, '');
        return str;
      }

      let timeLine = new Date(changeStr(timeNow)).getTime();
      let timeline = new Date(changeStr(timeBefore)).getTime();

      return (timeLine - timeline) / 1000 / 60;
    },

    handleById() {
      // console.log(this.clForm)
      let item = this.clForm;
      let time = new Date(+new Date() + 8 * 3600 * 1000)
        .toJSON()
        .substr(0, 19)
        .replace('T', ' ')
        .replace(/-/g, '/');
      let timeLine = new Date(time).getTime();

      item.dispose_time = new Date(timeLine).Format('yyyy年MM月dd日 hh:mm:ss');
      item.dealName = this.$local.get('userInfo').nickName;
      item.isLate = this.changeTime(item.dispose_time, item.nowtime);

      // let id = item._id
      // let type = item
      // var params={
      //   _id:id,
      //   content:this.clForm.content,
      //   wubao:this.clForm.wubao
      // }
      console.log(item);
      // return
      if (item.dosomthing == 0) {
        this.leftfiretopLoading = true;
        handleById(item).then((res) => {
          // this.getUnitNum()
          this.getInfo(item.c_company_num, this.companyInfoIndex, item.company);
          this.listParams.page = 1;
          // this.getHjList();
          //this.unitbjList[index].dosomthing = 1
          //this.$store.commit('saveBjList',this.unitbjList)
          this.$message('处理成功');
          this.leftfiretopLoading = false;
          // this.getLwList();
          this.getHistAll(this.listParams);
          this.getUnitNum();

          // this.gettime(this.listParams);

          this.showCL = false;
          this.resetCl();
          this.$store.commit('editBjList', item);
        });
      }
    },
    resetCl() {
      this.clForm = {
        content: '',
        wubao: false,
      };
    },
    makeline({ data, content, config }) {
      var option = {
        title: {
          show: false,
        },
        legend: {
          show: false,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985',
            },
          },
        },
        xAxis: [
          {
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            type: 'category',

            boundaryGap: false,
            data: [],
            axisLabel: {
              show: true,
              textStyle: {
                color: 'rgba(146, 146, 193, 1)',
                fontSize: '7px',
              },
            },
          },
        ],
        grid: {
          left: 20,
          right: 20,
          bottom: 25,
          top: 20,
        },
        yAxis: [
          {
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            name: '',
            type: 'value',
            splitLine: {
              show: false,
            },
            minInterval: 1,
            axisLabel: {
              show: false,
              textStyle: {
                color: '#000',
              },
            },
          },
        ],
        series: [
          {
            name: '昨天',
            type: 'line',
            stack: '昨天',

            data: this.onlineList.reverse(),
          },
          {
            name: '今天',
            type: 'line',
            stack: '今天',
            data: this.leaveList.reverse(),
            // data:[0,1,1,1,0,1,1]
          },
        ],
      };
      if (config) {
        option = { ...option, ...config };
      }
      echarts.init(document.getElementById(content)).setOption(option);
      this.deviceload = false;
    },
    makecir(arr) {
      /*消防综合评分*/
      echarts.init(document.getElementById('overall-rating')).setOption({
        title: {
          left: 'center',
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)',
        },
        // legend: {
        //     orient: 'vertical',
        //     left: 'left',
        //     data: ['安全管理得分', '安全管理失分', '消防设施得分', '消防设施失分', '建筑防火得分','建筑防火失分']
        // },
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: '65%',
            center: ['50%', '60%'],
            data: arr,
            itemStyle: {
              normal: {
                color: function(params) {
                  var colorList = ['#4472C4', '#7A9BD5', '#ED7D31', '#F6C29D', '#70AD47', '#A9D18E'];
                  return colorList[params.dataIndex];
                },
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      });
    },
  },
  watch: {
    // unit(){
    //     console.log(this.unit)
    // },
    // unitbjList(val) {
    //   // if (this.unitbjList[0]) {
    //   // setInterval(()=>{
    //   //     this.listParams.c_company_num = this.unitbjList[0].c_company_num;
    //   //   this.getInfoList(this.listParams,true);
    //   // },700)
    //   // }
    // },
    showCL(val) {
      if (!val) {
        this.$store.commit('DETAILALRAM', null);
      }
    },
    crtpoint(val) {
      if (!val) {
        this.$refs['crtmark']?.reset();
      }
    },
    alarmDtItem(val) {
      if (val && val.c_company_num) {
        this.CLdatail(null, val);
      }
    },
    showFire(val) {
      this.showMoreList = val;
    },
    showMoreList(val) {
      if (!val) {
        this.histAll = false;
        // this.getHistAll(this.listParams)
        this.listParams.starttime = '';
        this.listParams.endtime = '';
        this.companyInfo = [];
        this.listParams.evenClass = '火警';
        this.listParams.company = '';
      }
    },
    showMoreMsg(val) {
      if (val) {
        this.getHjMsg();
      }
    },
    // showMoreList(val) {
    //     console.log(val)
    //     if (val) {
    //         this.listParams.page = 1
    //         this.getHjList()
    //     }
    //     this.$store.state.showFire = val
    // },
    bjList(val) {
      // this.getUnitNum()
      // this.getHjList()
      // this.getUnitNum()

      if (val[0].police !== '0') {
        this.getInfoma();
        // this.getLwList()
      }
      setTimeout(() => {
        // this.getLwList(true)     //测试 是否置顶火警信息
        this.changPosition();
      }, 800);
    },

    showBD(val) {
      // log(this.editData)
      if (val) {
        setTimeout(() => {
          this.$post('/demarcate/findbyc_number/' + this.BDform.c_company_num).then((res) => {
            log(res);
            log(this.editData);
            this.editData = res.data.list || {};
            log(this.editData);
          });
        }, 200);
      } else {
        this.editData = {};
        this.$refs.searchForm.reset();
      }
    },
  },
};
</script>
<style scoped lang="scss">
.rankTable td {
  padding-bottom: 5px;
}
.gold {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 70%;
    height: 90%;
  }
}
.companActive {
  // color: linear-gradient();
  background-image: -webkit-linear-gradient(right, rgba(77, 161, 255, 1), rgba(77, 255, 223, 1));

  -webkit-background-clip: text;

  -webkit-text-fill-color: transparent;
}
// 顶部
.device-count-charts {
  width: 80px;
  height: 80px;
}
.device-online {
  height: 80%;
  width: 100%;
  justify-content: space-between;
  overflow: auto;
  .device-count-content {
    width: 45%;
    padding: 10px 0 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    .device-count-content-head {
      font-size: 24px;
      font-weight: 500;
      letter-spacing: 0.44px;
      border-radius: 12px 12px 0px 0px;
      display: flex;
      padding: 2px;
      justify-content: center;
      align-items: center;
      background: linear-gradient(rgba(125, 64, 255, 1), rgba(2, 164, 255, 1));
      .device-count-content-head-yin {
        background: #fff;
        border-radius: 12px 12px 0px 0px;
        padding: 5px 15px 5px;
      }

      // -webkit-border-image:linear-gradient(270deg, rgba(125, 64, 255, 1) 0%, rgba(2, 164, 255, 1) 100%)  30 30 ; /* Safari 5 */
      // -o-border-image:linear-gradient(270deg, rgba(125, 64, 255, 1) 0%, rgba(2, 164, 255, 1) 100%)  30 30 ; /* Opera */
      // border-image:linear-gradient(270deg, rgba(125, 64, 255, 1) 0%, rgba(2, 164, 255, 1) 100%)  30 30 ;
    }
    .device-count-content-end {
      width: 100px;
      margin-top: 10px;
    }
  }
}
.hj-unit-echart {
  display: flex;
}
.hg-top-online {
  top: 5px;
  height: 15%;
  scrollbar-width: none;
  padding-bottom: 4px;
  border-radius: 5px;
}
#overall-rating {
  height: 12vw;
}
#alarm-count-chart {
  height: 80%;
  margin: 20px;
  width: 100%;
}
.mark > td {
  color: red;
  font-weight: 500;
  // background: rgba(255,0,0,.4);
}
.hj-unite-message-content1 {
  width: 50%;
  height: 80%;
  overflow: auto;
  scrollbar-width: none;
  padding: 0px 0px 10px 15px;
  font-weight: 400;
}
.icondw {
  font-size: 13px;
  color: #fff;
  display: inline-block;
  border-radius: 50%;
  background: #4a9dff;
  padding: 5px;
}
.hj-message-increase {
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 0px;
  color: rgba(146, 146, 193, 1);
  text-align: left;
  vertical-align: top;
  .increase-num {
    color: rgba(94, 255, 90, 1);
  }
}
.hj-unit-title {
  padding-left: 15px;
}
.hj-unite-message-content1 ul li {
  width: 100%;
  display: flex;
}
.hj-unite-message-content-head {
  float: left;
  height: 28px;
  width: 50%;
  // height:30px;
}
.fontStyle-title {
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 0px;
  color: transparent;
  background: linear-gradient(270deg, rgba(125, 64, 255, 1) 0%, rgba(2, 164, 255, 1) 100%);
  -webkit-background-clip: text;
  text-align: left;
}
.mychart-sheshi-ui {
  width: 60px;
  height: 60px;
}
.hj-message-count {
  font-size: 32px;
  font-weight: 400;
  letter-spacing: 0px;
  color: transparent;
  background: linear-gradient(180deg, rgba(255, 146, 45, 0.7) 0%, rgba(255, 45, 46, 0.7) 100%);
  -webkit-background-clip: text;
  text-align: left;
}
.hj-unite-message-content-end {
  display: inline-block;
  word-break: break-all;
  float: left;
  font-size: 13px;
  flex: 1;
}
.right-tit {
  padding: 10px 15px 0;
  background: #fff;
  font-size: 14px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.left-tit {
  margin: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ddd;
}

.hj-message-table {
  width: 100%;
  margin-top: 5px;
  tr:nth-child(even) {
  }
  thead {
    tr {
      font-weight: 500;
      letter-spacing: 0px;
      line-height: 0px;
      color: rgba(62, 182, 238, 1) !important;
      text-align: left;
      vertical-align: top;
    }
  }
  td {
    line-height: 30px;
    font-weight: 400;
  }
  .active {
    background: #4a9dff !important;
    td,
    [class^='icon-']:before {
      color: #fff !important;
    }
  }
}
.blue {
  color: #999;
  font-size: 13px;
}
.selected {
  font-weight: 900;
  color: #000;
  // background:#4A9DFF
}
.red {
  font-weight: 900;
}
table {
  line-height: 1.8;
}

.more-msg,
.hj-message-gd {
  position: absolute;
  right: 11%;
  width: auto;
  left: auto;
}

.hj_list:hover {
  .main_navigation_shu_bar_hj {
    display: block;
  }
}

.hj_unite {
  cursor: pointer;

  &:hover {
    .main_navigation_shu_bar_hj_unit {
      display: block;
    }
  }
}

.hj-message-lw {
  &:hover {
    .main_navigation_shu_bar_lw_unit {
      display: block;
    }
  }
}

.hj-notice-yin1 {
  top: 50%;
}
// .hj-notice-yin6 {
//   top: 72%;
//     left: 0.2vw;
//     position: relative;

// }
.hj-message-tongji {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: rgba(20, 20, 43, 1);
}

.main_navigation_shu_bar_select {
  display: none;
}

.an-button {
  &:hover {
    .main_navigation_shu_bar_select {
      display: block;
    }
  }
}

.main_navigation_shu_bar_select {
  span {
    padding-left: 0;
  }
}

.hj-online-count {
  height: 100%;
}

.main_navigation_shu_bar_hj {
  display: none;
}
.hj-unite-message-body {
  height: 70%;
  width: 100%;
  scrollbar-width: none;
  overflow: auto;
}
.echart-end {
  text-align: left;
  display: flex;
  align-items: center;
}
.last-btn {
  margin-left: 92px;
}
.form-item {
  width: 100%;
}
.el-form-last {
  display: flex;
}
.last-form {
  display: flex;
  align-items: center;
  margin-bottom: 28px;
}
// .crtVideoDia {
//   height: 100vh;
//   width: 100vw;
// }
</style>
